export function preseterBindings($) {

  function generateCss(){

    let newCss = '';

    let sname = '';
    sname = 'color_bg';

    let $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += '.con-maindemo{ background-color: ' + $input.val() + '; } ';
    }
    sname = 'background';

    var selector = '#html5vg-preview';

    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += selector + '{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .navMain{ background-color: ' + $input.val() + '; }';
    }
    sname = 'controls_background';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {


      if (!get_query_arg(window.location.href, 'player_skin') || get_query_arg(window.location.href, 'player_skin') === 'skin_aurora' || get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {
        newCss += selector + ' .background{ background-color: ' + $input.val() + '; }';
      }


    }


    sname = 'scrub_background';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      if (!get_query_arg(window.location.href, 'player_skin') || get_query_arg(window.location.href, 'player_skin') === 'skin_aurora' || get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {
        newCss += selector + ' .scrub-bg{ background-color: ' + $input.val() + '; }';
      }
    }
    sname = 'scrub_buffer';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      if (!get_query_arg(window.location.href, 'player_skin') || get_query_arg(window.location.href, 'player_skin') === 'skin_aurora' || get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {
        newCss += selector + ' .scrub-buffer{ background-color: ' + $input.val() + '; }';
      }
    }
    sname = 'controls_color';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {

      if (get_query_arg(window.location.href, 'player_skin')) {

        if (get_query_arg(window.location.href, 'player_skin') === 'skin_aurora') {


          newCss += selector + ' .playSimple path{ fill: ' + $input.val() + '; } #html5vg-preview.videogallery .pauseSimple path{ fill: ' + $input.val() + '; }       #html5vg-preview.videogallery .volumeicon path{ fill: ' + $input.val() + '; }         #html5vg-preview.videogallery .fscreencontrols rect,#html5vg-preview.videogallery .fscreencontrols polygon{ fill: ' + $input.val() + '; }      #html5vg-preview.videogallery .hdbutton-con .hdbutton-normal{ color: ' + $input.val() + '; }  ';


        } else {


          if (get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {

            newCss += selector + ' .playSimple{ border-left-color: ' + $input.val() + '; } #html5vg-preview.videogallery .stopSimple .pause-part-1{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .stopSimple .pause-part-2{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .volumeicon{ background: ' + $input.val() + '; } #html5vg-preview.videogallery .volumeicon:before{ border-right-color: ' + $input.val() + '; } #html5vg-preview.videogallery .volume_static{ background: ' + $input.val() + '; } #html5vg-preview.videogallery .hdbutton-con .hdbutton-normal{ color: ' + $input.val() + '; } #html5vg-preview.videogallery .total-timetext{ color: ' + $input.val() + '; } ';
            var html5vg_preview = document.getElementById('html5vg-preview');

            if (html5vg_preview && html5vg_preview.api_currVideo_refresh_fsbutton) {

              html5vg_preview.api_currVideo_refresh_fsbutton($input.val());
            }
          }
        }
      } else {


        newCss += selector + ' .playSimple path{ fill: ' + $input.val() + '; } #html5vg-preview.videogallery .pauseSimple path{ fill: ' + $input.val() + '; }       #html5vg-preview.videogallery .volumeicon path{ fill: ' + $input.val() + '; }         #html5vg-preview.videogallery .fscreencontrols rect,#html5vg-preview.videogallery .fscreencontrols polygon{ fill: ' + $input.val() + '; }      #html5vg-preview.videogallery .hdbutton-con .hdbutton-normal{ color: ' + $input.val() + '; }  ';
      }
    }
    sname = 'controls_hover_color';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {


      if (get_query_arg(window.location.href, 'player_skin')) {

        if (get_query_arg(window.location.href, 'player_skin') === 'skin_aurora') {


          newCss += selector + ' .playcontrols:hover .playSimple path{ fill: ' + $input.val() + '; } #html5vg-preview.videogallery .playcontrols:hover .pauseSimple path{ fill: ' + $input.val() + '; }       #html5vg-preview.videogallery .volumecontrols:hover .volumeicon path{ fill: ' + $input.val() + '; }         #html5vg-preview.videogallery .fscreencontrols:hover rect,#html5vg-preview.videogallery .fscreencontrols:hover polygon{ fill: ' + $input.val() + '; }      #html5vg-preview.videogallery .hdbutton-con:hover .hdbutton-normal{ color: ' + $input.val() + '; }';


        } else {

          if (get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {
            newCss += selector + ' .playSimple:hover{ border-left-color: ' + $input.val() + '; } #html5vg-preview.videogallery .stopSimple:hover .pause-part-1{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .stopSimple:hover .pause-part-2{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .volumeicon:hover{ background: ' + $input.val() + '; } #html5vg-preview.videogallery .volumeicon:hover:before{ border-right-color: ' + $input.val() + '; }    #html5vg-preview.videogallery .hdbutton-con .hdbutton-normal:hover{ color: ' + $input.val() + '; } ';
            var html5vg_preview = document.getElementById('html5vg-preview');
            if (html5vg_preview && html5vg_preview.api_currVideo_refresh_fsbutton) {
              html5vg_preview.api_currVideo_refresh_fsbutton($input.val());
            }
          }


        }
      } else {

        newCss += selector + ' .playcontrols:hover .playSimple path{ fill: ' + $input.val() + '; } #html5vg-preview.videogallery .playcontrols:hover .pauseSimple path{ fill: ' + $input.val() + '; }       #html5vg-preview.videogallery .volumecontrols:hover .volumeicon path{ fill: ' + $input.val() + '; }         #html5vg-preview.videogallery .fscreencontrols:hover rect,#html5vg-preview.videogallery .fscreencontrols:hover polygon{ fill: ' + $input.val() + '; }      #html5vg-preview.videogallery .hdbutton-con:hover .hdbutton-normal{ color: ' + $input.val() + '; }';

      }
    }
    sname = 'controls_highlight_color';

    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      if (!get_query_arg(window.location.href, 'player_skin') || get_query_arg(window.location.href, 'player_skin') === 'skin_aurora' || get_query_arg(window.location.href, 'player_skin') === 'skin_pro') {

        newCss += selector + ' .volume_active{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .scrub{ background-color: ' + $input.val() + '; } #html5vg-preview.videogallery .hdbutton-con .hdbutton-hover{ color: ' + $input.val() + '; } ';
      }
    }
    sname = 'timetext_curr_color';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += selector + ' .curr-timetext{ color: ' + $input.val() + '; } ';
    }
    sname = 'thumbs_bg';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += selector + ' .navigationThumb{ background-color: ' + $input.val() + '; } ';
    }
    sname = 'thumbs_active_bg';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += selector + ' .navigationThumb.active, ' + selector + ' .navigationThumb:hover{ background-color: ' + $input.val() + '; } ';
    }
    sname = 'thumbs_text_color';
    $input = $('input[name="' + sname + '"]');
    if ($input.val()) {
      newCss += selector + ' .navigationThumb-content{ color: ' + $input.val() + '; } #html5vg-preview.videogallery .navigationThumb .the-title{ color: ' + $input.val() + '; } ';
    }


    return newCss;
  }





  const $dcInput = $('.dc-input');


  $dcInput.bind('change', function () {

    var _t = $(this);

    const newCss = generateCss();


    $('#html5vg-preview-style').html(newCss);
  });

  $dcInput.trigger('change');

}